import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const CeMarked = ({ ceMarked }: SpecProps<"ce_marked">) => {
  const { i18n } = useLingui();

  if (!ceMarked) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.ceMarked",
    message: "CE-marked",
    comment: "Label for 'CE-marked'",
  });

  return <FieldValuePair field={field} value={ceMarked} />;
};
